var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-relative"},[_c('a',{attrs:{"href":_vm.helpCenterUrl,"target":"_blank"}},[_c('SvgIcon',{staticClass:"tw-pointer-events-none help-menu-icon",attrs:{"name":"question-stroke"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }